import type { BoxProps } from "@chakra-ui/react";
import { AvatarAttributeTag } from "./AttributeTag";
import { BasePill } from "./BasePill";

export { BasePill };

export interface NewHireJourneyTagProps extends BoxProps {
  name: string;
  avatarUrl?: string;
  label?: string;
  href?: string;
}

export function NewHireJourneyTag({ name, avatarUrl, label = "Onboarding Journey", href, ...rest }: NewHireJourneyTagProps) {
  return <AvatarAttributeTag label={label} name={name} avatarUrl={avatarUrl} href={href} {...rest} />;
}

